var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "custom-itl__img",
    viewBox: "0 0 28 28"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#001138",
    fillRule: "evenodd",
    d: "M9.14 7.43A1.63 1.63 0 0 0 7.43 9a1.63 1.63 0 0 0 1.71 1.5A1.63 1.63 0 0 0 10.85 9a1.63 1.63 0 0 0-1.71-1.57m8.67 4.09A3.09 3.09 0 0 0 15 13v-1.21h-3v8.71h3v-4.73c0-1 .48-2 1.62-2s1.43 1 1.43 2v4.73h3.06v-4.95c0-3.44-2.07-4-3.34-4ZM7.6 20.5h3.07v-8.71H7.6Z"
  })));
};
export default SvgLinkedin;